import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

const RESERVED_OFFER_DETAILS_KEY = 'RESERVED_OFFER_DETAILS'
export const RESERVED_OFFER_ACTIONS = {
  ...generateApiActionTypes(RESERVED_OFFER_DETAILS_KEY),
  ...keymirror({ RESERVED_OFFER_DETAILS_RESET: null }),
}

export const getReservedOfferDetails = shipmentId => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.shipments,
      id: shipmentId,
      group: 'waterfall_info',
    },
    actionTypes: Object.keys(RESERVED_OFFER_ACTIONS),
  },
})

export const resetReservedOfferDetails = () => ({
  type: RESERVED_OFFER_ACTIONS.RESERVED_OFFER_DETAILS_RESET,
})
